import * as React from 'react'

const SvgAsleepFilledIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.375 1.875H9.25a8.181 8.181 0 001.137 16.25h.307a8.175 8.175 0 006.693-3.475.625.625 0 00-.512-.975 8.175 8.175 0 01-6.95-10.938.625.625 0 00-.55-.862z"
      fill="#163250"
    />
  </svg>
)

export default SvgAsleepFilledIcon
